export const STATUS_LABELS = {
    PENDING: "En attente",
    PUBLISHED: "Publiées",
    VALIDATED: "Validées",
    DELETED: "Supprimées",
    DELETE_REQUESTED: "Suppression demandée",
    CREATED: "Créé",
};

export const STATUS_COLORS = {
    PENDING: "warning",
    PUBLISHED: "info",
    VALIDATED: "success",
    DELETED: "default",
    DELETE_REQUESTED: "error",
    CREATED: "secondary",
};

export const TYPE_LABELS = {
    CP: "Congé payé",
    CSS: "Congé sans solde",
    M: "Maladie",
    RC: "Récupération",
    FO: "Fermeture",
    PT: "Partiel",
    AI: "Absence injustifiée",
};

export const TYPE_COLORS = {
    CP: "#1d4ed8",
    CSS: "#0ea5e9",
    M: "#f97316",
    RC: "#22c55e",
    FO: "#a855f7",
    PT: "#64748b",
    AI: "#ef4444",
    OTHER: "#94a3b8",
};

export const MONTH_LABELS = [
    "Jan",
    "Fév",
    "Mar",
    "Avr",
    "Mai",
    "Jun",
    "Jul",
    "Aoû",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];
